import { Tab } from "@headlessui/react";
import classNames from "classnames";
import { ReactNode } from "react";
import { Tabs, ActionTabHeaders, Props as TabsProps } from ".";

export type ActionTab = {
  tabHeading: ActionTabHeaders;
  content: ReactNode;
};

type Props = {
  tabs: ActionTab[];
  tabHeadingClassName?: string;
  tabContentClassName?: string;
} & Pick<
  TabsProps,
  | "tabStyle"
  | "onTabChange"
  | "selectedIndex"
  | "tabSpacing"
  | "extraContent"
  | "colour"
>;
export const TabsWithContent = ({
  tabs,
  tabSpacing,
  tabHeadingClassName,
  tabContentClassName,
  onTabChange,
  selectedIndex,
  tabStyle,
  extraContent,
  colour,
}: Props) => {
  return (
    <nav>
      <Tabs
        className={tabHeadingClassName}
        tabs={tabs.map((x) => x.tabHeading)}
        tabSpacing={tabSpacing}
        onTabChange={onTabChange}
        selectedIndex={selectedIndex}
        tabStyle={tabStyle}
        extraContent={extraContent}
        colour={colour}
      >
        <Tab.Panels
          className={classNames(tabContentClassName, {
            "pt-2": tabContentClassName === undefined,
          })}
        >
          {Object.values(tabs).map((tab) => (
            <Tab.Panel key={tab.tabHeading.id}>{tab.content}</Tab.Panel>
          ))}
        </Tab.Panels>
      </Tabs>
    </nav>
  );
};
